module.exports = __webpack_public_path__ + "static/media/gan-direct-avatar.ed8a5eb8.svg";